module.exports = __webpack_public_path__ + "static/media/homebg.3d491c20.jpg";